<template>
	<v-dialog
		v-model="visible_local" 
		persistent
		:retain-focus="false"
		:fullscreen="fullScreen"
		:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs: maxWidth"
	>
		<div class="dialog-container pb-3">
			<div class="top-line"></div>
			<div class="pt-3 px-6 task-title">
				<div class="title-text">Create&nbsp;&nbsp;{{ current_event.text }}</div>
				<v-icon v-if="isClose" @click.stop="$emit('close')">mdi-close</v-icon>
			</div>
			<div class="event-btn pt-3 px-6">
				<v-btn
					v-for="create_item in createObj"
					:key="create_item.value"
					depressed
					class="text-capitalize mr-3"
					:color="create_item.value === current_event.value ? color: '#FFFFFF'"
					@click="current_event = create_item"
				>
					<span class="button-text" :class="create_item.value === current_event.value ?'button-text-current':'button-text-uncurrent'">{{ create_item.text }}</span>
				</v-btn>
			</div>
			<NewTimeSheet v-if="current_event.value === timesheet_key" :color="color" :adbid="adbid" :joid="joid" :tasid="tasid" :startTime="startTime" :endTime="endTime" @close="$emit('close')"/>
			<NewTask v-if="current_event.value === task_key" :color="color" :tasid="tasid" :joid="joid" :jpid="jpid" :startTime="startTime" @close="$emit('close')"/>
			<NewItem v-if="current_event.value === item_key" :color="color" :joid="joid" :startTime="startTime" @close="$emit('close')"/>
			<NewEvent v-if="current_event.value === event_key" :color="color" :adbid="adbid" :joid="joid" :coid="coid" :startTime="startTime" @close="$emit('close')"/>
			<NewLeave v-if="current_event.value === leave_key" :color="color" :startTime="startTime" @close="$emit('close')"/>
			<NewHoliday v-if="current_event.value === holiday_key" :color="color" :startTime="startTime" @close="$emit('close')"/>
		</div>
	</v-dialog>
</template>
<script>
import NewTimeSheet from "@/views/timesheets/new_timesheet.vue";
import NewTask from "@/views/tasks/new_task.vue";
import NewItem from "@/views/items/new_item.vue";
import NewEvent from "@/views/events/new_event.vue";
import NewLeave from "@/views/events/new_leave.vue";
import NewHoliday from "@/views/events/new_holiday.vue";

const TASK = 'task';
const TIMESHEET = 'timesheet';
const ITEM = 'item';
const EVENT = 'event';
const LEAVE = 'leave';
const HOLIDAY = 'holiday'

export default {
	name: 'CreateEventDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 750
		},
		color: {
			type: String,
			default: ''
		},
		createObj: {
			type: Array,
			default: () => []
		},
		/**
		 * 0=>timesheet(default), 1=>task, 2=>event, 3=>item, 4=>holiday
		 * base on order of create_items in config.js
		 */
		currentTab: {
			type: Number,
			default: 0
		},
		/**
		 * false => hide the close icon, defaul => true
		 */
		isClose: {
			type: Boolean,
			default: true
		},
		fullScreen: {
			type: Boolean,
			default: false
		},
		adbid: {
			type: Number,
			default: 0
		},
		joid: {
			type: Number,
			default: 0
		},
		coid: {
			type: Number,
			default: 0
		},
		tasid: {
			type: Number,
			default: 0
		},
		startTime: {
			type: String,
			default: ''
		},
		endTime: {
			type: String,
			default: ''
		},
		jpid: {
			type: Number,
			default: 0
		}
	},
	data() {
		this.task_key = TASK;
		this.timesheet_key = TIMESHEET;
		this.item_key = ITEM;
		this.event_key = EVENT;
		this.leave_key = LEAVE;
		this.holiday_key = HOLIDAY;
		this.maxWidth_xs = '100%';
    
		return {
			error_msg: '',
			visible_local: this.visible,
			current_event: null,
		}
	},
	created() {
		this.current_event =  this.createObj.length > 1 ? (this.createObj.filter(c => { return c.key === this.currentTab}))[0] : this.createObj[0];
	},
	components: {
		NewTimeSheet,
		NewTask,
		NewItem,
		NewEvent,
		NewLeave,
		NewHoliday
	},
	watch: {
		visible_local() {
			if (!this.visible_local) {
				this.$emit('close');
			}
		}
	},
}
</script>
<style lang="scss" scoped>
.dialog-container {
	background: #FFFFFF;
  border-radius: 4px;
}
.event-btn {
  display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
  align-items: center;
}
.top-line {
  width: 100%;
  height: 4px;
  background: #81CC00;
  border-radius: 4px 4px 0px 0px;
}
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #81CC00;
}
.button-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 0.5px;
}
.button-text-current {
  color: #609800;
}
.button-text-uncurrent {
  color: #82899B;
}
.item-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	color: #37495F;
	opacity: 0.87;
}
</style>